import { useId } from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';

const EmptyState = ({
  image,
  imageAlt = '',
  title,
  description,
  actionLabel,
  actionHref,
  onAction,
  actionVariant = 'primary2',
  actionTarget,
  secondaryActionLabel,
  secondaryActionHref,
  onSecondaryAction,
  className
}) => {
  const titleId = useId();
  const actionProps = actionHref
    ? { as: 'a', href: actionHref, target: actionTarget, rel: actionTarget === '_blank' ? 'noopener noreferrer' : undefined }
    : { onClick: onAction };

  return (
    <section
      className={classNames(
        'empty-state d-flex flex-column align-items-center justify-content-center bg-white rounded-4 text-center p-4 p-md-5',
        className
      )}
      aria-labelledby={titleId}
    >
      <img src={image} alt={imageAlt} className="empty-state-image mb-3" />
      <h4 id={titleId} className="fs-4 fw-bold mb-2">
        {title}
      </h4>
      <p className="empty-state-description fs-7 text-gray mb-0">
        {description}
      </p>
      {actionLabel && (
        <Button
          type={actionHref ? undefined : 'button'}
          variant={actionVariant}
          className="mt-4 px-4 py-2 fs-6 fw-bold text-white"
          {...actionProps}
        >
          {actionLabel}
        </Button>
      )}
      {secondaryActionLabel && (
        <Button
          as={secondaryActionHref ? 'a' : 'button'}
          type={secondaryActionHref ? undefined : 'button'}
          href={secondaryActionHref}
          variant="link"
          className="mt-3 p-0 fs-6 text-primary2"
          onClick={onSecondaryAction}
        >
          {secondaryActionLabel}
        </Button>
      )}
    </section>
  );
};

export default EmptyState;
